import React, { useCallback, useEffect, useMemo, useState , useRef } from "react";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Input,
  Chip,
  Pagination,
  Tabs,
  Tab,
  Divider,
  Spinner,
  Select,
  SelectItem,
  useDisclosure,
} from "@nextui-org/react";
import {
  setNotifications,
  setAllNotifications,
  addNotification,
  deleteNotification as deleteNotifFromStore,
  setAdminNotifications,
  addAdminNotification,
  deleteAdminNotification,
} from "../store/slices/notificationSlice";

import { refreshIfNeeded } from "../store/actions/refreshIfNeeded";

import { FiPlus, FiSearch } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Link } from "react-router-dom";
import { columns } from "../data/enquiriesData";
import { changeStatus, getMake, getMode } from "../store/slices/customerSlice";
import { useDispatch, useSelector } from "react-redux";
import { STATUS } from "../store/constants";
import { displayDate, formatTime } from "../utils";
import { BiHide } from "react-icons/bi";
import axios from "axios";
import ConfirmationModal from "./ConfirmationModal";
import { notification } from "../store/slices/notificationSlice";

import { toast } from "react-toastify";
import { PiFlagPennantFill } from "react-icons/pi";
/* -------------------------------------------------- */
/*  CONSTANTS                                         */
/* -------------------------------------------------- */
const statusColorMap = {
  new: "primary",
  "in progress": "warning",
  "awaiting approval": "warning",
  accepted: "success",
  dispute: "danger",
  rejected: "danger",
  discarded: "danger",
  cancelled: "danger",
};
const INITIAL_VISIBLE_COLUMNS = [
  "status",
  "car",
  "industry",
  "part",
  "duration",
  "delete",
];
/* -------------------------------------------------- */
/*  COMPONENT                                         */
/* -------------------------------------------------- */
const Enquiries = ({ emitDelete }) => {
  const dispatch = useDispatch();
  const role = localStorage.getItem("role"); // "CUSTOMER" / "SUPPLIER"
  const { status, makes, model: modelOptions } = useSelector((s) => s.customer);
  const notifications = useSelector(
    (state) => state.notification.notifications
  );
  /* ---------------- state ---------------- */
  const [visibleColumns, setVisibleColumns] = useState(() => {
    let columns = [...INITIAL_VISIBLE_COLUMNS];
    if (role === "CUSTOMER") {
      // remove the "delete" column entirely for CUSTOMERS
      columns = columns.filter((col) => col !== "delete");
    }
    return new Set(columns);
  });

  // for debounced search we keep immediate input + debounced filterValue
  const [searchTerm, setSearchTerm] = useState(""); // immediate input
  const [filterValue, setFilterValue] = useState(""); // debounced value (used in API)

  const [statusFilter, setStatusFilter] = useState("all");
  const [requests, setRequests] = useState([]);
  /* supplier-side filters */
  const [selectedMakes, setSelectedMakes] = useState([]); // numbers
  const [selectedModels, setSelectedModels] = useState([]); // numbers
  /* ui */
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [page, setPage] = useState(() => {
    const stored = localStorage.getItem("currentPage");
    return stored ? Number(stored) : 1;
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const confirmModal = useDisclosure();

  /* ---------------- sorting data ---------------- */
  const [sortDescriptor, setSortDescriptor] = useState({
    column: null,
    direction: null, // "ascending" | "descending"
  });

  /* ---------------- stable refs (prevent re-creation) ---------------- */
    const searchTimerRef = useRef(null);
  const filterRef = useRef(filterValue);
  const sortRef = useRef(sortDescriptor);

const [allRequests, setAllRequests] = useState([]);
const [allDataLoaded, setAllDataLoaded] = useState(false);
const [batchPage, setBatchPage] = useState(0);
const fetchingRef = useRef(false);

const batchSize = 100; // same as Orders/Quotes

  useEffect(() => {
    filterRef.current = filterValue;
  }, [filterValue]);

  
  /* ---------------- helper: fetch models list ---------------- */
  const fetchModelsForMake = useCallback(
    (idsString) => {
      if (idsString) dispatch(getMode(idsString));
    },
    [dispatch]
  );
  /* ---------------- helper: fetch requests ------------------- */
  // const fetchData = useCallback(async ({pageParam = 1, replace = true } = {}) => {
  //   try {
  //     dispatch(changeStatus(STATUS.LOADING));
  //     await dispatch(refreshIfNeeded());
  //     const fresh = localStorage.getItem("accessToken");
  //     const auth = { headers: { Authorization: `Bearer ${fresh}` } };
  //     const qp = new URLSearchParams();
  //     qp.append("page", pageParam);
  //     qp.append("pageSize", 100);
  //     if (selectedMakes.length) qp.append("make", selectedMakes.join(","));
  //     if (selectedModels.length) qp.append("model", selectedModels.join(","));
  //     if (statusFilter !== "all") qp.append("status", statusFilter);

  //       // search & sort come from refs to avoid re-creating callback on each change
  //       const curFilter = filterRef.current;
  //       const curSort = sortRef.current;

  //       if (curFilter) qp.append("search", curFilter);
  //     if (curSort?.column) {
  //       qp.append("sortBy", curSort.column);
  //         qp.append("sortOrder", curSort.direction === "ascending" ? "asc" :"desc");
  //     }

  //     const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/requests/?${qp}`, auth);
  //     const rows = data.details?.rows ?? [];

  //       if (replace) {
  //         setRequests(rows);
  //       } else {
  //         // append but avoid duplicates
  //         setRequests((prev) => {
  //           const prevIds = new Set(prev.map((r) => r.id));
  //           const uniqueNew = rows.filter((r) => !prevIds.has(r.id));
  //           return [...prev, ...uniqueNew];
  //         });
  //       }

  //     setTotalRecords(data.details?.index?.totalRecords ?? rows.length);
  //     dispatch(changeStatus(STATUS.IDLE));
  //   } catch (err) {
  //     console.error("fetchData error:", err);
  //     dispatch(changeStatus(STATUS.ERROR));
  //   }
  // }, [dispatch, selectedMakes, selectedModels, statusFilter]);
  /* ---------------- initial load & when debounced filters / sort / rows change ---------------- */

  const fetchBatch = useCallback(
  async (batchNum, { replace = false } = {}) => {
    if (fetchingRef.current) return;
    if (allDataLoaded && !replace) return;

    try {
      fetchingRef.current = true;
      dispatch(changeStatus(STATUS.LOADING));
      await dispatch(refreshIfNeeded());
      const fresh = localStorage.getItem("accessToken");
      const auth = { headers: { Authorization: `Bearer ${fresh}` } };

      const qp = new URLSearchParams();
      qp.append("page", batchNum);
      qp.append("pageSize", batchSize);

      if (selectedMakes.length) qp.append("make", selectedMakes.join(","));
      if (selectedModels.length) qp.append("model", selectedModels.join(","));
      if (statusFilter !== "all") qp.append("status", statusFilter);
      if (sortDescriptor.column) {
        qp.append("sortBy", sortDescriptor.column);
        qp.append(
          "sortOrder",
          sortDescriptor.direction === "ascending" ? "asc" : "desc"
        );
      }
      if (filterValue.trim()) qp.append("search", filterValue);

      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/requests/?${qp}`,
        auth
      );
      const fetchedRows = res.data?.details?.rows || [];
      const totalRecords = res.data?.details?.index?.totalRecords || 0;
      const backendCurrentPage = res.data?.details?.index?.currentPage || batchNum;

      setTotalRecords(totalRecords);

      if (replace || batchNum === 1) {
        setAllRequests(fetchedRows);
      } else {
        setAllRequests((prev) => {
          const prevIds = new Set(prev.map((r) => r.id));
          const uniqueNew = fetchedRows.filter((r) => !prevIds.has(r.id));
          return [...prev, ...uniqueNew];
        });
      }

      setBatchPage(backendCurrentPage);
      setAllDataLoaded(fetchedRows.length < batchSize);
      dispatch(changeStatus(STATUS.IDLE));
    } catch (err) {
      console.error("fetchBatch error:", err);
      dispatch(changeStatus(STATUS.ERROR));
    } finally {
      fetchingRef.current = false;
    }
  },
  [
    dispatch,
    batchSize,
    selectedMakes,
    selectedModels,
    statusFilter,
    sortDescriptor,
    filterValue,
    allDataLoaded,
  ]
);
const ensurePageData = useCallback(
  async (uiPage) => {
    const requiredEndIndex = uiPage * rowsPerPage;
    if (requiredEndIndex <= allRequests.length) return;
    if (allDataLoaded) return;

    const requiredBatch = Math.ceil(requiredEndIndex / batchSize);
    for (let b = batchPage + 1; b <= requiredBatch; b++) {
      await fetchBatch(b);
    }
  },
  [fetchBatch, allRequests.length, allDataLoaded, batchPage, rowsPerPage]
);

  // useEffect(() => {
  //   // when filterValue / sortDescriptor / rowsPerPage changes we reset and fetch page 1
  //   setRequests([]);
  //   setPage(1);
  //   fetchData({ pageParam: 1, replace: true });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [filterValue, sortDescriptor.column, sortDescriptor.direction, rowsPerPage, selectedMakes.join(","), selectedModels.join(","), statusFilter]);

  useEffect(() => {
  setAllRequests([]);
  setAllDataLoaded(false);
  setBatchPage(0);
  setPage(1);
  fetchBatch(1, { replace: true }).catch(console.error);
}, [filterValue, selectedMakes, selectedModels, statusFilter, sortDescriptor, rowsPerPage]);

useEffect(() => {
  const id = setInterval(() => {
    if (!fetchingRef.current)
      fetchBatch(1, { replace: true }).catch(() => {});
  }, 120000);
  return () => clearInterval(id);
}, [fetchBatch]);


  /* ---------------- debounce for input (searchTerm -> filterValue) ---------------- */
  const onSearchChange = useCallback((val) => {
    setSearchTerm(val); // immediate UI
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    searchTimerRef.current = setTimeout(() => {
      setFilterValue(val.trim());
      localStorage.setItem("currentPage", 1);
      setPage(1);
      searchTimerRef.current = null;
    }, 500);
  }, []);

  const onClear = useCallback(() => {
    setSearchTerm("");
    if (searchTimerRef.current) {
      clearTimeout(searchTimerRef.current);
      searchTimerRef.current = null;
    }
    setFilterValue("");
    setRequests([]);
    setPage(1);
    localStorage.setItem("currentPage", 1);
  }, []);

  useEffect(() => {
    return () => {
      if (searchTimerRef.current) {
        clearTimeout(searchTimerRef.current);
        searchTimerRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    console.log("Redux notifications data:", notifications);
  }, [notifications]);

  useEffect(() => {
    if (role === "SUPPLIER") dispatch(getMake());
  }, [role, dispatch]);
  /* ---------------- make/model handlers (supplier) ---------------- */
  const handleMakeChange = (keys) => {
    const list = [...keys].map(Number);
    setSelectedMakes(list);
    setSelectedModels([]); // clear model filter whenever make changes
    fetchModelsForMake(list.join(","));
    setPage(1);
  };
  const handleModelChange = (keys) => {
    const list = [...keys].map(Number);
    setSelectedModels(list);
    setPage(1);
  };
  const clearSupplierFilters = () => {
    setSelectedMakes([]);
    setSelectedModels([]);
    setFilterValue("");
    setStatusFilter("all");
    confirmModal.onClose();
  };
 
  /* ---------------- client filtering, sorting & pagination (unchanged UI behavior) ---------------- */
  const filteredItems = useMemo(() => {
    let data = [...allRequests];
    if (filterValue.trim()) {
      const q = filterValue.toLowerCase();
      data = data.filter(
        (d) =>
          d.VehicleMake?.name?.toLowerCase().includes(q) ||
          d.VehicleModel?.name?.toLowerCase().includes(q) ||
          d.Part?.name?.toLowerCase().includes(q) ||
          d.User?.first_name?.toLowerCase().includes(q) ||
          d.User?.last_name?.toLowerCase().includes(q)
      );
    }
    if (statusFilter !== "all") {
      // data = data.filter((d) =>
      //   statusFilter.includes(d.RequestStatus.status.toLowerCase())
      // );

      data = data.filter(
        (d) => d.RequestStatus.status.toLowerCase() === statusFilter
      );
    }
    return data;
  }, [allRequests, filterValue, statusFilter]);
  const pages = Math.max(1, Math.ceil( totalRecords / rowsPerPage));
  
  /* ---------------- notification helpers ---------------- */
  const headerColumns = useMemo(
    () => columns.filter((c) => visibleColumns.has(c.uid)),
    [visibleColumns]
  );
  const handleHide = async (id) => {
    try {
      await dispatch(refreshIfNeeded());
      const fresh = localStorage.getItem("accessToken");
      await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/quotes/hiderequest/${id}`,
        {},
        { headers: { Authorization: `Bearer ${fresh}` } }
      );
      toast.success("Request hidden");
      fetchBatch({ pageParam: 1, replace: true });
    } catch (error) {
      console.error("Error hiding request:", error);
      toast.error("Failed to hide request");
    }
  };
  const handleNotificationClear = (requestId) => {
    const relatedNotifs = notifications.filter(
      (n) => n.group === "COMMENT" && n.related_id === requestId
    );

    if (relatedNotifs.length) {
      relatedNotifs.forEach((notif) => {
        dispatch(deleteNotifFromStore(notif.id));
        emitDelete(notif.id); // ✅ Now this will remove it from DB via socket
      });
    }
  };

  const getSortValue = (item, column) => {
    switch (column) {
      case "car":
        return `${item.VehicleMake?.name || ""}`.toLowerCase();
      case "duration":
        return item.date_requested;
      case "part":
        return item.Part?.name || item.custom_part_type || "";
      case "industry":
        return item.User?.Industry || "";
      default:
        return item[column] || "";
    }
  };
  // 1. Sorting logic
  const sortedItems = useMemo(() => {
    if (!sortDescriptor.column) return filteredItems;
    return [...filteredItems].sort((a, b) => {
      let first = getSortValue(a, sortDescriptor.column);
      let second = getSortValue(b, sortDescriptor.column);

      // date
      const firstDate = new Date(first);
      const secondDate = new Date(second);
      if (!isNaN(firstDate) && !isNaN(secondDate)) {
        const cmp = firstDate - secondDate;
        return sortDescriptor.direction === "ascending" ? cmp : -cmp;
      }

      // 2️⃣ Try numeric comparison
      const firstNum = parseFloat(first);
      const secondNum = parseFloat(second);
      if (!isNaN(firstNum) && !isNaN(secondNum)) {
        const cmp = firstNum - secondNum;
        return sortDescriptor.direction === "ascending" ? cmp : -cmp;
      }

      // 3️⃣ Fallback to string comparison
      const cmp = first
        .toString()
        .localeCompare(second.toString(), undefined, { sensitivity: "base" });
      console.log("String comparison:", first, second, "Result:", cmp);
      return sortDescriptor.direction === "ascending" ? cmp : -cmp;
    });
  }, [filteredItems, sortDescriptor]);

  // 2. Pagination applied AFTER sorting
  const pagedItems = useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    return sortedItems.slice(start, start + rowsPerPage);
  }, [sortedItems, page, rowsPerPage]);

  const renderCell = useCallback(
    (item, columnKey) => {
      const hasSupplierComment = notifications.some(
        (n) =>
          n.group === "COMMENT" &&
          n.message?.toLowerCase().includes("from supplier") &&
          n.related_id === item.id
      );

      switch (columnKey) {
        case "status":
          return (
            <div className="flex items-center gap-2">
              <Chip
                variant="flat"
                className="capitalize"
                color={statusColorMap[item.RequestStatus.status.toLowerCase()]}
              >
                {item.RequestStatus.status === "In progress"
                  ? "Awaiting Approval"
                  : item.RequestStatus.status}
              </Chip>

              {hasSupplierComment && (
                <PiFlagPennantFill
                  className="text-blue-400 text-sm"
                  title="New Supplier Comment"
                />
              )}
            </div>
          );

        case "industry":
          return (
            role === "SUPPLIER" && (
              <p className="table_cell">
                {item.User?.Industry || "Not Provided"}
              </p>
            )
          );
        case "car":
          return (
            <div className="flex flex-col gap-1">
              <p className="table_cell capitalize">
                {item.VehicleMake?.name?.toLowerCase() ||
                  item.custom_make?.toLowerCase() ||
                  "Not Provided"}{" "}
                {item.VehicleModel ? item.VehicleModel.name : item.custom_model}
              </p>
              <p className="table_cell_sm">Year: {item.year}</p>
            </div>
          );
        case "part":
          return (
            <p className="table_cell capitalize">
              {item.Part?.name?.toLowerCase() ||
                item.custom_part_type ||
                "Not Provided"}
            </p>
          );
        case "duration":
          return (
            <div className="flex flex-col gap-1">
              <p className="table_cell capitalize">
                {formatTime(item.date_requested)}
              </p>
              <p className="table_cell_sm">
                {displayDate(item.date_requested)}
              </p>
            </div>
          );
        case "delete": {
          const role = localStorage.getItem("role");
          if (role !== "SUPPLIER") {
            return null;
          }
          return (
            <div className="flex items-center gap-2 text-lg">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleHide(item.id);
                }}
              >
                <BiHide className="text-blue-500 cursor-pointer" />
              </button>
            </div>
          );
        }
        default:
          return item[columnKey];
      }
    },
    [role, notifications]
  );
  /* ---------------- event handlers for sort & page ---------------- */
  const onSortChange = useCallback((newSort) => {
    setSortDescriptor(newSort);
    // update ref immediately so effect uses latest
    sortRef.current = newSort;
    setPage(1);
    localStorage.setItem("currentPage", 1);
  }, []);

  const onPageChange = useCallback((newPage) => {
    setPage(newPage);
    localStorage.setItem("currentPage", newPage);
  }, []);

  /* ---------------- render JSX (kept structure same) ---------------- */
  return (
    <>
      <Table
        aria-label="Requests Table"
        isHeaderSticky
        isStriped
        sortDescriptor={sortDescriptor}
        onSortChange={onSortChange}
        topContent={
          <div className="flex flex-col gap-6">
            {/* search / filter row */}
            <div className="flex justify-between gap-3 items-end w-full">
              {role === "CUSTOMER" ? (
                <Input
                  isClearable
                  className="w-full sm:max-w-[44%]"
                  placeholder="Search Requests..."
                  startContent={<FiSearch />}
                  value={searchTerm}
                  onClear={onClear}
                  onValueChange={(val) => onSearchChange(val)}
                />
              ) : (
                <div className="md:grid grid-cols-3 gap-1 capitalize ">
                  {/* make */}
                  <Select
                    labelPlacement="outside"
                    variant="bordered"
                    selectionMode="single"
                    className="w-full sm:w-[220px]"
                    placeholder="Select Make"
                    label="Make"
                    selectedKeys={new Set(selectedMakes.map(String))}
                    onSelectionChange={handleMakeChange}
                  >
                    {makes.map(
                      (m) =>
                        m.id !== 0 && (
                          <SelectItem key={String(m.id)} className="capitalize">
                            {m.name.toLowerCase()}
                          </SelectItem>
                        )
                    )}
                  </Select>
                  {/* model */}
                  <Select
                    labelPlacement="outside"
                    variant="bordered"
                    selectionMode="single"
                    className="w-full sm:w-[220px] capitalize"
                    placeholder="Select Model"
                    label="Model"
                    disabledKeys={modelOptions.length ? [] : ["null"]}
                    selectedKeys={new Set(selectedModels.map(String))}
                    onSelectionChange={handleModelChange}
                  >
                    {modelOptions.map(
                      (m) =>
                        m.id !== 0 && (
                          <SelectItem key={String(m.id)}>
                            {m.name.toLowerCase()}
                          </SelectItem>
                        )
                    )}
                  </Select>
                  {/* clear */}
                  <div className="flex justify-center items-center h-[95px] ">
                    <button
                      className="bg-red-400 text-white font-semibold px-6 py-2 mt-auto rounded-md hover:bg-red-700"
                      onClick={confirmModal.onOpen}
                    >
                      Clear All Selections
                    </button>
                  </div>
                </div>
              )}
              {role === "CUSTOMER" && (
                <Button
                  endContent={
                    <FiPlus
                      color="white"
                      className="text-[0.65rem] sm:text-lg"
                    />
                  }
                  className="bg-lightBlue text-white text-[0.65rem] sm:text-base"
                >
                  <Link to="/requests/create">Create Request</Link>
                </Button>
              )}
            </div>
            {/* tabs + rows selector */}
            <div className="flex flex-col-reverse sm:flex-row flex-wrap items-center justify-between gap-y-4">
              <Tabs
                variant="underlined"
                selectedKey={statusFilter}
                onSelectionChange={(key) => {
                  setStatusFilter(key);
                  setPage(1);
                }}
              >
                <Tab key="all" title="All Requests" />
                <Tab key="new" title="New Requests" />
                <Tab key="awaiting approval" title="Awaiting Approval" />
              </Tabs>
              <div className="flex items-center gap-5 text-xs sm:text-sm text-default-400 capitalize">
                {/* {notifications.some(
                  (item) =>
                    item.group === "COMMENT" &&
                    item.message?.startsWith(
                      "You have a new comment from supplier"
                    )
                ) ? (
                  <p>comments</p>
                ) : (
                  <></>
                )} */}

                {/* {notifications
                  .filter((item) => item.group === "COMMENT")
                  .map((item) => (
                    <div key={item.id} className="mb-2 p-2 border rounded">
                      <p className="text-sm text-gray-700 font-semibold">
                        Comment ID: {item.related_id}
                      </p>
                    </div>
                  ))} */}
                <span>Total: {totalRecords} Requests</span>
                <Divider orientation="vertical" className="h-6" />
                <label className="flex items-center">
                  Rows per page:&nbsp;
                  <select
                    className="bg-transparent outline-none"
                    value={rowsPerPage}
                    onChange={(e) => {
                      setRowsPerPage(Number(e.target.value));
                      setPage(1);
                    }}
                  >
                    <option value="6">6</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        }
        topContentPlacement="outside"
        bottomContent={
          <div className="py-2 flex justify-center">
            <Pagination
              isCompact
              showControls
              color="primary"
              page={page}
              total={pages}
              onChange={(newPage) => {
                setPage(newPage);
                ensurePageData(newPage);
                  }}
            />
          </div>
        }
        bottomContentPlacement="outside"
        classNames={{ td: "whitespace-nowrap" }}
      >
        {/* header */}
        <TableHeader columns={headerColumns}>
          {(col) => (
            <TableColumn
              key={col.uid}
              //  allowsSorting={col.sortable}
              allowsSorting={true} // ✅ enable sorting
              className="capitalize"
            >
              {role === "CUSTOMER" && col.name === "Industry" ? "" : col.name}
            </TableColumn>
          )}
        </TableHeader>
        {/* body */}
        <TableBody
          items={pagedItems}
          emptyContent="No Requests Found"
          isLoading={status === STATUS.LOADING && !allRequests.length}
          loadingContent={<Spinner label="Loading..." />}
        >
          {(item) => (
            <TableRow key={item.id}>
              {(colKey) => (
                <TableCell>
                  {colKey === "icon" ? (
                    <Button size="sm" color="error">
                      <RiDeleteBin6Line className="text-xl text-red-500" />
                    </Button>
                  ) : role === "SUPPLIER" ? (
                    // <Link to={`/requestDetails/${item.id}`}>
                    //   {renderCell(item, colKey)}
                    // </Link>
                    <a
                      href={`/requestDetails/${item.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {renderCell(item, colKey)}
                    </a>
                  ) : (
                    //                    <Link
                    //   to={`/requests/${item.id}`}

                    //   onClick={() => handleNotificationClear(item.id)}
                    // >
                    //   {renderCell(item, colKey)}
                    // </Link>

                    <a
                      href={`/requests/${item.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {renderCell(item, colKey)}
                    </a>
                  )}
                </TableCell>
              )}
            </TableRow>
          )}
        </TableBody>
      </Table>
      {/* confirm modal */}
      {confirmModal.isOpen && (
        <ConfirmationModal
          isOpen={confirmModal.isOpen}
          onClose={confirmModal.onClose}
          onConfirm={clearSupplierFilters}
        />
      )}
    </>
  );
};
export default Enquiries;
